import SharingTypes from 'store/actionTypes/sharing'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  pagination: {},
  filter: {}
}

const sharing = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case SharingTypes.GET_LIST_OF_SHARING_SUCCESS:
      return {
        ...state,
        list: payload?.vehicleSharings?.items,
        pagination: payload?.vehicleSharings?.meta
      }
    case SharingTypes.UPDATE_FILTER_LIST_OF_SHARING_SUCCESS:
      return { ...state, filter: payload }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default sharing
